import { render, staticRenderFns } from "./AppStatus.vue?vue&type=template&id=28fa978e&scoped=true&"
import script from "./AppStatus.vue?vue&type=script&lang=js&"
export * from "./AppStatus.vue?vue&type=script&lang=js&"
import style0 from "./AppStatus.vue?vue&type=style&index=0&id=28fa978e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa978e",
  null
  
)

export default component.exports